/**
 * CetusEd NextGen — the protected-route guard (⛔2 FAIL CLOSED).
 *
 * ONLY an `authenticated` status (a valid access token held in memory RIGHT
 * NOW) renders the protected outlet. `unknown`/`restoring` render a neutral
 * loading state — never protected content, because a not-yet-known session is
 * not a session. Anything else redirects to /login. There is no "assume signed
 * in" branch; an absent or guessed token renders nothing protected.
 */
import { Navigate, Outlet } from 'react-router-dom'
import { useSession } from '../../core/session/SessionProvider'
import { SessionLoading } from './SessionLoading'

export function ProtectedRoute() {
  const { status } = useSession()

  if (status === 'unknown' || status === 'restoring') {
    return <SessionLoading label="Checking your session…" />
  }

  if (status !== 'authenticated') {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
